import { useSessionAuth } from '@/context/Auth';
import {
  UpdateOrderStatusPayload,
  updateOrderStatus,
} from '@/infrastructure/api/order';
import { Order } from '@/infrastructure/domain/order';
import {
  UseMutationResult,
  useMutation,
  useQueryClient,
} from '@tanstack/react-query';

export type UpdateOrderStatusAttrs = {
  orderId: string;
  payload: UpdateOrderStatusPayload;
};

export const useUpdateOrderStatus = (
  roomId?: string,
): UseMutationResult<Order, Error, UpdateOrderStatusAttrs, unknown> | null => {
  const queryClient = useQueryClient();
  const { token } = useSessionAuth();

  return useMutation({
    mutationFn: ({ orderId, payload }: UpdateOrderStatusAttrs) =>
      updateOrderStatus(token!, orderId, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['cart'] });
      queryClient.invalidateQueries({ queryKey: ['orders'] });
      queryClient.invalidateQueries({ queryKey: ['chatRooms'] });
      if (roomId) {
        queryClient.invalidateQueries({ queryKey: ['chatMessages', roomId] });
      }
    },
  });
};
